<template>
  <div class="switcher-contrast">
    <v-btn 
      @click="handleContrastClick"
      icon="mdi mdi-brightness-6" 
      variant="text"
      title="Zmień kontrast">
    </v-btn>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, Ref } from 'vue';
import store                              from '@/store';

const ContrastSwitcher: object = defineComponent({
  name: 'ContrastSwitcher',
  props: {
  },
  setup() {
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    const handleContrastClick = () => store.commit('flipContrastActive');

    
    return {
      getContrastActive,
      handleContrastClick,
    };
  },
});
export default ContrastSwitcher;
</script>

<style scoped lang="scss">

.switcher-contrast {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  transition: transform ease-in-out 0.3s,
  opacity ease-in-out 0.3s;
  box-sizing: border-box;
}
</style>
